module.exports = __webpack_public_path__ + "static/media/mail-icon-white.23527a9e.svg";